module.exports = __webpack_public_path__ + "images/keep-access-acb094e98a5182886d24af720f75eef8.jpg";